var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyCode(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 468,
    height: 414,
    viewBox: "0 0 468 414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy-code",
    transform: "translate(-814 -976)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1130",
    "data-name": "Rectangle 1130",
    width: 468,
    height: 414,
    transform: "translate(814 976)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "copy-code-2",
    "data-name": "copy-code",
    transform: "translate(814 976.066)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble",
    "data-name": "Speech Bubble",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_831",
    "data-name": "Rectangle 831",
    width: 95.017,
    height: 179.613,
    transform: "translate(54.386 187.954)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_832",
    "data-name": "Rectangle 832",
    width: 95.017,
    height: 179.613,
    transform: "translate(26.181 187.954)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1935",
    "data-name": "Path 1935",
    d: "M121.172,266.738H39.61V238.27h81.562Zm-80.556-1h79.551V239.276H40.616Z",
    transform: "translate(-6.965 -41.823)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1936",
    "data-name": "Path 1936",
    d: "M71,238.88h30.95v2.168a3.5,3.5,0,0,1-3.5,3.5H74.537a3.5,3.5,0,0,1-3.537-3.5V238.88Z",
    transform: "translate(-12.476 -41.93)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1937",
    "data-name": "Path 1937",
    d: "M121.172,310.608H39.61V282.14h81.562Zm-80.556-1h79.551V283.138H40.616Z",
    transform: "translate(-6.965 -49.523)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1938",
    "data-name": "Path 1938",
    d: "M71,282.75h30.95v2.168a3.5,3.5,0,0,1-3.5,3.5H74.537a3.5,3.5,0,0,1-3.537-3.5Z",
    transform: "translate(-12.476 -49.631)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1939",
    "data-name": "Path 1939",
    d: "M121.172,354.476H39.61V326h81.562Zm-80.556-1h79.551V327.006H40.616Z",
    transform: "translate(-6.965 -57.222)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1940",
    "data-name": "Path 1940",
    d: "M71,326.61h30.95v2.168a3.5,3.5,0,0,1-3.5,3.5H74.537a3.5,3.5,0,0,1-3.537-3.5Z",
    transform: "translate(-12.476 -57.329)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1941",
    "data-name": "Path 1941",
    d: "M121.172,398.346H39.61V369.87h81.562ZM40.616,397.34h79.551V370.876H40.616Z",
    transform: "translate(-6.965 -64.922)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1942",
    "data-name": "Path 1942",
    d: "M71,370.48h30.95v2.168a3.5,3.5,0,0,1-3.5,3.5H74.537a3.5,3.5,0,0,1-3.537-3.5V370.48Z",
    transform: "translate(-12.476 -65.03)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_833",
    "data-name": "Rectangle 833",
    width: 103.212,
    height: 8.945,
    transform: "translate(21.969 181.227)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_834",
    "data-name": "Rectangle 834",
    width: 31.032,
    height: 8.945,
    transform: "translate(125.181 181.227)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_835",
    "data-name": "Rectangle 835",
    width: 4.996,
    height: 9.176,
    transform: "translate(26.181 367.567)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_836",
    "data-name": "Rectangle 836",
    width: 4.996,
    height: 9.176,
    transform: "translate(57.032 367.567)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_837",
    "data-name": "Rectangle 837",
    width: 4.996,
    height: 9.176,
    transform: "translate(113.391 367.567)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_838",
    "data-name": "Rectangle 838",
    width: 4.996,
    height: 9.176,
    transform: "translate(141.571 367.567)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1943",
    "data-name": "Path 1943",
    d: "M100.8,190.56l9.613,24.61-5.977-.033-4.79-15.12Z",
    transform: "translate(-17.505 -33.448)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1944",
    "data-name": "Path 1944",
    d: "M60.506,162.99,57.2,210.132l34.132.717,3.842-47.859Z",
    transform: "translate(-10.053 -28.609)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1945",
    "data-name": "Path 1945",
    d: "M64.764,167.541,62.01,206.784l25.376,1.187,3.545-40.662Z",
    transform: "translate(-10.897 -29.367)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1946",
    "data-name": "Path 1946",
    d: "M71.671,174.32,69.61,201.906h14l2.465-27.586Z",
    transform: "translate(-12.232 -30.598)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_839",
    "data-name": "Rectangle 839",
    width: 110.162,
    height: 108.241,
    transform: "translate(129.798)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_840",
    "data-name": "Rectangle 840",
    width: 102.445,
    height: 102.445,
    transform: "translate(133.623 2.96)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_841",
    "data-name": "Rectangle 841",
    width: 33.423,
    height: 33.423,
    transform: "translate(168.143 37.471)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1947",
    "data-name": "Path 1947",
    d: "M322.133,12.08c-1.245,17.767,0,50.843-6.464,67.431s-15.1,33.67-31.279,41.09c-19.935,9.135-43.358,5.268-64.62,10.619-33.324,8.385-57.423,38.963-67.712,71.727s-9.143,67.918-7.906,102.231l170.091,23.6s.9-69.113,15.73-87.976,85.305-35.839,108.579-87.5c20.949-46.49,27.264-120.22,27.264-120.22Z",
    transform: "translate(-25.18 -2.121)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1948",
    "data-name": "Path 1948",
    d: "M443.983,101.112c0,.239-15.533-1.649-34.627-4.279S374.837,91.887,374.87,91.7s15.524,1.649,34.627,4.287S444.016,100.881,443.983,101.112Z",
    transform: "translate(-65.822 -16.093)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1949",
    "data-name": "Path 1949",
    d: "M441.721,117.911c0,.231-15.524-1.649-34.627-4.287s-34.528-4.9-34.495-5.128,15.524,1.649,34.627,4.279S441.754,117.68,441.721,117.911Z",
    transform: "translate(-65.423 -19.041)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1950",
    "data-name": "Path 1950",
    d: "M434.043,135.039c0,.231-15.533-1.69-34.627-4.287s-34.519-4.9-34.487-5.136,15.516,1.649,34.627,4.287S434.068,134.8,434.043,135.039Z",
    transform: "translate(-64.077 -22.045)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1951",
    "data-name": "Path 1951",
    d: "M420.041,152.319c0,.231-15.524-1.69-34.627-4.287s-34.528-4.9-34.495-5.136,15.524,1.649,34.627,4.287S420.074,152.047,420.041,152.319Z",
    transform: "translate(-61.617 -25.079)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1952",
    "data-name": "Path 1952",
    d: "M397.771,169.561c0,.231-15.524-1.649-34.627-4.287s-34.528-4.9-34.495-5.128,15.524,1.649,34.627,4.279S397.8,169.322,397.771,169.561Z",
    transform: "translate(-57.707 -28.107)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1953",
    "data-name": "Path 1953",
    d: "M492.678,108.122c0,.239-3.842-.19-8.5-.948s-8.409-1.566-8.368-1.8,3.842.19,8.5.948S492.719,107.891,492.678,108.122Z",
    transform: "translate(-83.542 -18.485)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1954",
    "data-name": "Path 1954",
    d: "M448.1,83.991c0,.231-15.524-1.649-34.627-4.287S379,74.807,379,74.576s15.524,1.649,34.627,4.279S448.138,83.752,448.1,83.991Z",
    transform: "translate(-66.547 -13.089)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1955",
    "data-name": "Path 1955",
    d: "M496.806,91c0,.231-3.85-.19-8.508-.948s-8.409-1.566-8.368-1.8,3.842.19,8.508.948S496.839,90.771,496.806,91Z",
    transform: "translate(-84.265 -15.483)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1956",
    "data-name": "Path 1956",
    d: "M452.761,66.861c0,.239-15.524-1.649-34.627-4.279s-34.528-4.9-34.495-5.136,15.524,1.649,34.627,4.287S452.794,66.63,452.761,66.861Z",
    transform: "translate(-67.361 -10.081)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1957",
    "data-name": "Path 1957",
    d: "M501.466,73.872c-.041.239-3.85-.19-8.508-.948s-8.409-1.566-8.368-1.8,3.842.19,8.508.956S501.5,73.641,501.466,73.872Z",
    transform: "translate(-85.084 -12.476)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1958",
    "data-name": "Path 1958",
    d: "M454.941,49.741c0,.231-15.524-1.649-34.627-4.287s-34.528-4.9-34.495-5.128,15.524,1.649,34.627,4.279S454.974,49.5,454.941,49.741Z",
    transform: "translate(-67.744 -7.076)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1959",
    "data-name": "Path 1959",
    d: "M503.646,56.747c-.041.231-3.85-.19-8.508-.948s-8.4-1.566-8.368-1.814,3.85.19,8.508.948S503.688,56.516,503.646,56.747Z",
    transform: "translate(-85.466 -9.465)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1960",
    "data-name": "Path 1960",
    d: "M491.946,123.1c0,.231-3.842-.2-8.5-.956s-8.409-1.558-8.376-1.8,3.85.2,8.508.956S491.988,122.861,491.946,123.1Z",
    transform: "translate(-83.412 -21.113)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1961",
    "data-name": "Path 1961",
    d: "M486.868,143.816c0,.231-3.85-.214-8.517-.989S469.9,141.243,470,141.07c0-.3,3.842.148,8.492.915S486.909,143.585,486.868,143.816Z",
    transform: "translate(-82.522 -24.746)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1962",
    "data-name": "Path 1962",
    d: "M479.528,161.406c0,.239-3.85-.214-8.517-.981s-8.442-1.591-8.352-1.764,3.842.148,8.492.915S479.569,161.134,479.528,161.406Z",
    transform: "translate(-81.233 -27.841)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1963",
    "data-name": "Path 1963",
    d: "M463.746,178.026c0,.231-3.85-.214-8.516-.989s-8.451-1.583-8.36-1.756,3.85.148,8.5.915S463.787,177.795,463.746,178.026Z",
    transform: "translate(-78.461 -30.759)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1964",
    "data-name": "Path 1964",
    d: "M371.355,189.511c0,.239-23.291-2.861-51.94-6.917s-51.858-7.535-51.825-7.766,23.282,2.861,51.94,6.917S371.388,189.28,371.355,189.511Z",
    transform: "translate(-46.988 -30.685)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1965",
    "data-name": "Path 1965",
    d: "M355.073,206.486a5.178,5.178,0,0,1-1.146-.091l-3.3-.429-11.946-1.748-39.573-6.1c-15.45-2.473-29.424-4.691-39.524-6.381l-11.963-2.069c-1.41-.256-2.473-.462-3.24-.618a6.326,6.326,0,0,1-1.113-.289,6.854,6.854,0,0,1,1.146.115l3.3.462,12,1.8,39.573,6.142,39.524,6.34,11.963,2.02,3.248.594a6.162,6.162,0,0,1,1.055.256Z",
    transform: "translate(-42.719 -33.133)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1966",
    "data-name": "Path 1966",
    d: "M329.2,222.786c.148.148-1.517,0-4.271-.371s-6.826-.915-11.8-1.649c-9.951-1.443-23.678-3.529-38.831-5.895s-28.856-4.576-38.749-6.225l-11.74-1.987-3.182-.585a6.44,6.44,0,0,1-1.1-.256,5.035,5.035,0,0,1,1.13.091l3.215.42,11.715,1.731,38.831,5.969,38.79,6.15Z",
    transform: "translate(-38.549 -36.126)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1967",
    "data-name": "Path 1967",
    d: "M437.406,201.725c-.041.231-3.85-.214-8.517-.989s-8.451-1.583-8.36-1.756c0-.3,3.842.14,8.5.915S437.406,201.495,437.406,201.725Z",
    transform: "translate(-73.837 -34.91)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1968",
    "data-name": "Path 1968",
    d: "M417.056,213.043c0,.231-3.85-.214-8.516-.989s-8.451-1.583-8.36-1.764,3.85.148,8.5.915S417.1,212.8,417.056,213.043Z",
    transform: "translate(-70.265 -36.903)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1969",
    "data-name": "Path 1969",
    d: "M389.7,232.1c-.041.231-3.858-.214-8.516-.989s-8.451-1.583-8.36-1.756c0-.3,3.842.14,8.5.915S389.737,231.865,389.7,232.1Z",
    transform: "translate(-65.461 -40.241)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1970",
    "data-name": "Path 1970",
    d: "M313.685,258.575c0,.231-28.781-4-64.2-9.448s-64.117-10.058-64.076-10.289,28.773,4,64.208,9.448S313.685,258.344,313.685,258.575Z",
    transform: "translate(-32.561 -41.921)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1971",
    "data-name": "Path 1971",
    d: "M311.156,299.069c0,.239-9.465-1.1-21.048-2.968s-20.949-3.578-20.908-3.817,9.456,1.1,21.048,2.976S311.189,298.838,311.156,299.069Z",
    transform: "translate(-47.271 -51.299)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1972",
    "data-name": "Path 1972",
    d: "M440.606,189.62c-4.765.1-7.643,5.54-7.89,10.3s1.047,9.63-.115,14.246c-1.484,5.87-6.686,10.281-8.038,16.176-1.6,6.958,2.515,13.9,3.042,21.015.256,3.463-.338,7.008.47,10.38a12.779,12.779,0,0,0,25.047-.973c.824-5.392-1.781-10.949-.627-16.283.824-3.949,3.718-7.42,3.768-11.435.058-4.807-3.85-8.764-4.773-13.48s1.253-9.465,1.377-14.263c.223-8.615-3.661-15.186-12.259-15.664",
    transform: "translate(-74.481 -33.282)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1973",
    "data-name": "Path 1973",
    d: "M445.919,216.9a4.8,4.8,0,0,1,0,.758c-.041.544-.082,1.27-.148,2.193-.14,1.937-.346,4.666-.594,8.03-.5,6.785-1.2,16.159-1.9,26.514s-1.278,19.737-1.69,26.531c-.206,3.364-.379,6.1-.495,8.038-.066.915-.115,1.649-.157,2.185a4.949,4.949,0,0,1-.082.759,4.853,4.853,0,0,1,0-.759c0-.544,0-1.27.066-2.193.091-1.946.206-4.683.354-8.047.33-6.8.824-16.184,1.558-26.547s1.443-19.729,2.036-26.506c.3-3.355.552-6.084.734-8.022.1-.915.173-1.649.231-2.185a4.744,4.744,0,0,1,.082-.75Z",
    transform: "translate(-77.403 -38.071)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1974",
    "data-name": "Path 1974",
    d: "M439.653,322.905h0a15.2,15.2,0,0,0,15.2-15.2V292.5H424.45v15.2a15.211,15.211,0,0,0,15.2,15.2Z",
    transform: "translate(-74.526 -51.341)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1975",
    "data-name": "Path 1975",
    d: "M424.45,301.51a2.118,2.118,0,0,1,.5.33l1.327,1.039,4.708,3.809h-.256l8.772-5.375h0l.14-.082.14.091,8.154,5.375h-.256l5.153-3.8,1.459-1.039a2.557,2.557,0,0,1,.544-.33,4.359,4.359,0,0,1-.462.437l-1.385,1.129-5.046,3.957-.115.091-.14-.082-8.195-5.309h.247l-8.805,5.3-.14.082-.115-.1-4.584-3.957-1.2-1.13a2.581,2.581,0,0,1-.453-.437Z",
    transform: "translate(-74.526 -52.874)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1976",
    "data-name": "Path 1976",
    d: "M424.45,297.822a2.033,2.033,0,0,1,.5.338l1.327,1.031L430.988,303h-.256l8.772-5.367h0l.14-.082.14.091,8.154,5.375h-.256l5.153-3.8,1.459-1.039a2.56,2.56,0,0,1,.544-.33,4.362,4.362,0,0,1-.462.437l-1.385,1.138-5,3.924-.115.1-.14-.091-8.2-5.309h.28l-8.805,5.293-.14.082-.115-.1-4.584-3.949-1.27-1.113a2.253,2.253,0,0,1-.453-.437Z",
    transform: "translate(-74.526 -52.228)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1977",
    "data-name": "Path 1977",
    d: "M424.45,305.26a2.118,2.118,0,0,1,.5.33l1.327,1.039,4.708,3.809h-.256l8.772-5.375h0l.14-.082.14.091,8.154,5.375h-.256l5.169-3.8,1.459-1.039a2.557,2.557,0,0,1,.544-.33,4.369,4.369,0,0,1-.462.437l-1.385,1.129-5.021,3.924-.115.091-.14-.082-8.2-5.309h.206l-8.78,5.3-.14.082-.148-.082-4.584-3.957L424.9,305.7a2.581,2.581,0,0,1-.453-.437Z",
    transform: "translate(-74.526 -53.533)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1978",
    "data-name": "Path 1978",
    d: "M466.5,422.51l9.712,27.833h-4.856L454.37,422.51Z",
    transform: "translate(-79.778 -74.16)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1979",
    "data-name": "Path 1979",
    d: "M399.484,422.51l-9.7,27.833h4.848L411.62,422.51Z",
    transform: "translate(-68.439 -74.16)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_842",
    "data-name": "Rectangle 842",
    width: 77.547,
    height: 77.547,
    transform: "translate(385.507 349.048) rotate(180)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_843",
    "data-name": "Rectangle 843",
    width: 77.547,
    height: 77.547,
    transform: "translate(409.804 349.048) rotate(180)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1980",
    "data-name": "Path 1980",
    d: "M476.538,403.229H409.23v-67.3h67.308Zm-66.3-1h65.3v-65.3h-65.3Z",
    transform: "translate(-71.854 -58.963)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1981",
    "data-name": "Path 1981",
    d: "M475.689,361.181c-21.889-.635-44.017-.47-65.955,0a.264.264,0,1,0,0,.528c21.9.445,44.025.61,65.955,0a.239.239,0,0,0,0-.47Z",
    transform: "translate(-71.896 -63.324)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1982",
    "data-name": "Path 1982",
    d: "M447.76,349.318a1.888,1.888,0,1,0,1.888-1.888,1.888,1.888,0,0,0-1.888,1.888Z",
    transform: "translate(-78.618 -60.984)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1983",
    "data-name": "Path 1983",
    d: "M480.74,386.058a1.888,1.888,0,1,0,1.888-1.888,1.888,1.888,0,0,0-1.888,1.888Z",
    transform: "translate(-84.408 -67.433)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1984",
    "data-name": "Path 1984",
    d: "M245.588,438.148,99.942,272.2a12.367,12.367,0,0,1,1.154-17.5L202.5,165.711a12.367,12.367,0,0,1,17.5,1.138L365.627,332.768a12.367,12.367,0,0,1-1.146,17.5L263.075,439.253a12.367,12.367,0,0,1-17.486-1.1Z",
    transform: "translate(-17.014 -28.534)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1985",
    "data-name": "Path 1985",
    d: "M364.008,370.759a16.951,16.951,0,1,1,1.558-23.909A16.951,16.951,0,0,1,364.008,370.759Z",
    transform: "translate(-58.975 -59.867)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1986",
    "data-name": "Path 1986",
    d: "M372.138,394.008a18.308,18.308,0,0,1-4.312.239,17.684,17.684,0,1,1,4.312-.239Zm-6.027-33.374a16.134,16.134,0,1,0,13.5,28.031h0a16.134,16.134,0,0,0-9.6-28.254A16.75,16.75,0,0,0,366.112,360.634Z",
    transform: "translate(-61.688 -62.999)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1987",
    "data-name": "Path 1987",
    d: "M158.261,257.411l-10.248,8.995-.923-1.055,9.308-8.162-2.119-2.424.932-.824Z",
    transform: "translate(-25.834 -44.573)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1988",
    "data-name": "Path 1988",
    d: "M159.027,277.778l-.94.824-6.307-7.181.75-.66,7.906.6c2.152.148,3.034-.231,3.743-.824,1.179-1.039,1.179-2.473-.2-4.081a4.609,4.609,0,0,0-3.595-1.8V263.35a6.126,6.126,0,0,1,4.65,2.35c1.822,2.078,1.921,4.32.214,5.821-.981.824-2.127,1.327-4.683,1.129l-6.48-.478Z",
    transform: "translate(-26.657 -46.225)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1989",
    "data-name": "Path 1989",
    d: "M172.519,289.917l-1.8-2.053-2.7,2.366-.923-1.055,2.7-2.358-5.079-5.771.758-.668,11.542-.528,1.031,1.171-11.212.569,3.9,4.444,2.374-2.078.9,1.022-2.374,2.078,1.806,2.053Z",
    transform: "translate(-28.929 -49.121)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1990",
    "data-name": "Path 1990",
    d: "M189.239,308.965l-1.806-2.053-2.688,2.366-.923-1.055,2.688-2.366-5.07-5.771.759-.668,11.542-.528,1.022,1.171-11.212.569,3.9,4.444L189.825,303l.9,1.022-2.374,2.078,1.8,2.053Z",
    transform: "translate(-31.864 -52.463)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1991",
    "data-name": "Path 1991",
    d: "M199.059,318.97c-1.74,1.525-4.122,1.509-6.365-1a7.016,7.016,0,0,1-1.9-4.823l1.286-.223a5.9,5.9,0,0,0,1.575,4.188c1.525,1.74,3.182,1.921,4.427.824s1.418-2.7-.824-5.3l-1.913-2.177,5.6-3.982,4.947,5.606-.94.824-4.122-4.683-3.57,2.514,1.162,1.319C201.063,315.153,200.857,317.379,199.059,318.97Z",
    transform: "translate(-33.505 -53.796)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1992",
    "data-name": "Path 1992",
    d: "M210.025,331.4c-1.921,1.649-4.477,1.253-6.216-.742-2.391-2.721-1.806-5.854,1.435-8.7,3.479-3.05,6.967-2.745,9.407.041a6.241,6.241,0,0,1,1.575,2.91l-1.22.33a4.782,4.782,0,0,0-1.261-2.416c-1.946-2.21-4.609-2.383-7.42.058-.231.206-.519.47-.824.775a4.345,4.345,0,0,1,4.51,1.591C211.847,327.276,211.9,329.749,210.025,331.4Zm-.948-1.014c1.352-1.179,1.344-2.935-.049-4.518s-3.3-1.789-4.551-.668c-1.121.989-1.369,2.861.181,4.633,1.3,1.476,3.059,1.748,4.419.552Z",
    transform: "translate(-35.534 -56.132)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1993",
    "data-name": "Path 1993",
    d: "M224.691,348.149c-1.715,1.5-4.122,1.41-6.291-1.064a7.074,7.074,0,0,1-1.921-4.839l1.286-.223a5.953,5.953,0,0,0,1.6,4.221c1.492,1.7,3.1,1.937,4.378.824s1.278-2.646-.4-4.543l-.643-.734.775-.684,6.051-.28-4.6-5.243.94-.824,5.771,6.6-.75.66-6.183.3C226.522,344.6,226.332,346.706,224.691,348.149Z",
    transform: "translate(-38.015 -58.76)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1994",
    "data-name": "Path 1994",
    d: "M235.886,360.86c-1.913,1.649-4.468,1.261-6.216-.734-2.391-2.721-1.8-5.854,1.435-8.7,3.487-3.05,6.967-2.745,9.407.041a6.266,6.266,0,0,1,1.583,2.91l-1.228.33a4.716,4.716,0,0,0-1.261-2.416c-1.937-2.218-4.609-2.383-7.42.049-.231.214-.511.478-.824.783a4.345,4.345,0,0,1,4.5,1.583C237.716,356.746,237.757,359.219,235.886,360.86Zm-.94-1.014c1.344-1.179,1.336-2.927-.049-4.51s-3.3-1.789-4.551-.668c-1.129.989-1.377,2.861.181,4.633,1.294,1.476,3.059,1.74,4.419.544Z",
    transform: "translate(-40.075 -61.304)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1995",
    "data-name": "Path 1995",
    d: "M253.073,365.519l-.75.651-13.257,4.048-1.006-1.138,13.01-3.957-4.625-5.268-1.913,1.649-.915-1.031L246.469,358Z",
    transform: "translate(-41.804 -62.839)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1996",
    "data-name": "Path 1996",
    d: "M268.665,383.284l-.742.651-13.257,4.048-1.006-1.138,13.01-3.957-4.625-5.285-1.921,1.649-.907-1.039,2.853-2.473Z",
    transform: "translate(-44.543 -65.953)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1997",
    "data-name": "Path 1997",
    d: "M271.894,402.32c-1.822,1.591-4.3,1.047-6.439-1.4s-2.341-4.947-.528-6.53a3.405,3.405,0,0,1,4.254-.239,3.067,3.067,0,0,1,.824-3.586c1.649-1.459,3.949-.956,5.854,1.212s2.135,4.526.462,5.986a3.075,3.075,0,0,1-3.685.346,3.446,3.446,0,0,1-.742,4.213Zm-.94-1.1c1.261-1.1,1.1-2.886-.495-4.7s-3.3-2.185-4.576-1.08-1.129,2.877.462,4.691,3.372,2.185,4.609,1.08Zm.338-5.433c1.4,1.6,2.951,1.921,4.064.94s.973-2.638-.371-4.172-2.927-1.921-4.073-.915-1.014,2.548.379,4.139Z",
    transform: "translate(-46.304 -68.409)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1998",
    "data-name": "Path 1998",
    d: "M284.752,412.33c-3.487,3.059-6.967,2.745-9.407,0a6.158,6.158,0,0,1-1.575-2.919l1.22-.322a4.749,4.749,0,0,0,1.261,2.416c1.937,2.209,4.6,2.383,7.42-.058.231-.206.511-.478.824-.775a4.353,4.353,0,0,1-4.5-1.591c-1.789-2.036-1.83-4.51.041-6.15s4.468-1.253,6.216.734C288.577,406.353,287.975,409.494,284.752,412.33Zm.758-3.232c1.13-.989,1.377-2.869-.181-4.642-1.294-1.476-3.059-1.74-4.419-.544s-1.336,2.935.049,4.518,3.281,1.8,4.543.668Z",
    transform: "translate(-48.073 -70.543)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1999",
    "data-name": "Path 1999",
    d: "M301.881,421.059l-10.248,8.986-.923-1.055,9.308-8.17L297.9,418.4l.932-.824Z",
    transform: "translate(-51.047 -73.295)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2000",
    "data-name": "Path 2000",
    d: "M302.647,441.419l-.94.824-6.307-7.181.75-.66,7.906.6c2.152.148,3.034-.231,3.735-.824,1.187-1.039,1.187-2.515-.19-4.081a4.609,4.609,0,0,0-3.595-1.8V427a6.126,6.126,0,0,1,4.65,2.35c1.822,2.078,1.921,4.32.214,5.821-.981.824-2.127,1.327-4.683,1.129l-6.48-.478Z",
    transform: "translate(-51.87 -74.949)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2001",
    "data-name": "Path 2001",
    d: "M314.651,450.649c-1.715,1.5-4.122,1.41-6.291-1.064a7.115,7.115,0,0,1-1.921-4.84l1.286-.223a5.952,5.952,0,0,0,1.6,4.221c1.492,1.7,3.1,1.938,4.378.824s1.278-2.646-.4-4.551l-.643-.734.775-.676,6.051-.28-4.6-5.243.94-.824,5.771,6.6-.75.66-6.183.3C316.482,447.1,316.292,449.206,314.651,450.649Z",
    transform: "translate(-53.808 -76.75)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_844",
    "data-name": "Rectangle 844",
    width: 5.92,
    height: 109.206,
    transform: "matrix(0.751, -0.66, 0.66, 0.751, 176.708, 308.225)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_845",
    "data-name": "Rectangle 845",
    width: 5.92,
    height: 56.013,
    transform: "translate(202.907 356.057) rotate(-41.27)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_846",
    "data-name": "Rectangle 846",
    width: 45.823,
    height: 34.231,
    rx: 4.96,
    transform: "translate(161.406 176.158) rotate(48.73)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2002",
    "data-name": "Path 2002",
    d: "M173.22,231.457l1.649-1.443,15.557,17.734a4.947,4.947,0,0,0,7.42-6.521L182.3,223.493l1.649-1.443,15.566,17.734a7.131,7.131,0,1,1-10.719,9.408Z",
    transform: "translate(-30.421 -38.976)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_847",
    "data-name": "Rectangle 847",
    width: 2.193,
    height: 16.192,
    transform: "translate(166.892 210.771) rotate(-41.22)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_848",
    "data-name": "Rectangle 848",
    width: 117.846,
    height: 10.116,
    transform: "translate(186.152 161.648) rotate(48.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2003",
    "data-name": "Path 2003",
    d: "M259.68,377.6H224.187v31.576l-10.3,18.352h56.087l-10.3-18.352Z",
    transform: "translate(-37.561 -66.276)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_849",
    "data-name": "Rectangle 849",
    width: 286.445,
    height: 186.3,
    rx: 14.77,
    transform: "translate(61.154 126.23)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_850",
    "data-name": "Rectangle 850",
    width: 85.858,
    height: 9.019,
    transform: "translate(161.44 361.252)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2004",
    "data-name": "Path 2004",
    d: "M353.924,179.082V317.926a13.142,13.142,0,0,1-13.191,13.15H97.662a13.191,13.191,0,0,1-13.142-13.15V179.082A13.142,13.142,0,0,1,97.662,165.94H340.774a13.133,13.133,0,0,1,13.15,13.142Z",
    transform: "translate(-14.849 -29.124)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_851",
    "data-name": "Rectangle 851",
    width: 55.996,
    height: 20.05,
    transform: "translate(176.371 268.457)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2005",
    "data-name": "Path 2005",
    d: "M233.208,333.21a4.345,4.345,0,0,1,1.517,2.539h-2.4a2.283,2.283,0,0,0-.824-1.022,2.26,2.26,0,0,0-1.3-.363,2,2,0,0,0-1.608.726,2.952,2.952,0,0,0-.6,1.946,2.91,2.91,0,0,0,.6,1.937,2,2,0,0,0,1.608.725,2.2,2.2,0,0,0,2.119-1.377h2.4a4.353,4.353,0,0,1-1.517,2.531,4.551,4.551,0,0,1-2.96.948,4.633,4.633,0,0,1-2.4-.6,4.123,4.123,0,0,1-1.6-1.69,5.771,5.771,0,0,1,0-4.947,4.122,4.122,0,0,1,1.6-1.69,5.111,5.111,0,0,1,5.359.338Z",
    transform: "translate(-39.631 -58.323)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2006",
    "data-name": "Path 2006",
    d: "M244.981,332.868a4.5,4.5,0,0,1,1.7,1.707,4.84,4.84,0,0,1,.627,2.473,4.947,4.947,0,0,1-.627,2.473,4.51,4.51,0,0,1-1.715,1.715,4.947,4.947,0,0,1-4.782,0,4.543,4.543,0,0,1-1.707-1.715,5.194,5.194,0,0,1,0-4.947,4.584,4.584,0,0,1,1.707-1.707,4.947,4.947,0,0,1,4.8,0Zm-4.172,2.21a3.3,3.3,0,0,0,0,3.933,2.276,2.276,0,0,0,1.764.726,2.3,2.3,0,0,0,1.764-.726,3.3,3.3,0,0,0,0-3.924,2.531,2.531,0,0,0-3.537,0Z",
    transform: "translate(-41.767 -58.319)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2007",
    "data-name": "Path 2007",
    d: "M253.127,338.454v3.3H250.86v-9.374h3.669a3.537,3.537,0,0,1,2.539.824,2.919,2.919,0,0,1,.874,2.234,3.033,3.033,0,0,1-.371,1.575,2.745,2.745,0,0,1-1.154,1.072,4.187,4.187,0,0,1-1.871.388Zm2.515-3.017c0-.824-.453-1.228-1.369-1.228h-1.146v2.432h1.146C255.188,336.64,255.642,336.245,255.642,335.437Z",
    transform: "translate(-44.051 -58.34)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2008",
    "data-name": "Path 2008",
    d: "M268.756,332.38l-3.248,6.282v3.116h-2.275v-3.116L260,332.38h2.6L264.4,336.2l1.8-3.817Z",
    transform: "translate(-45.656 -58.342)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2009",
    "data-name": "Path 2009",
    d: "M353.924,179.082v69.542H84.52V179.082A13.142,13.142,0,0,1,97.662,165.94H340.774a13.133,13.133,0,0,1,13.15,13.142Z",
    transform: "translate(-14.849 -29.126)",
    fill: "#007cff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_852",
    "data-name": "Rectangle 852",
    width: 170.396,
    height: 112.339,
    transform: "translate(119.179 148.085)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_853",
    "data-name": "Rectangle 853",
    width: 167.428,
    height: 101.489,
    transform: "translate(120.638 156.495)",
    fill: "#352628"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_854",
    "data-name": "Rectangle 854",
    width: 165.482,
    height: 99.898,
    transform: "translate(121.611 157.294)",
    fill: "#443637"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_855",
    "data-name": "Rectangle 855",
    width: 6.587,
    height: 3.924,
    transform: "translate(133.912 164.911)",
    fill: "#ff5240"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_856",
    "data-name": "Rectangle 856",
    width: 37.265,
    height: 3.924,
    transform: "translate(143.195 164.911)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_857",
    "data-name": "Rectangle 857",
    width: 24.354,
    height: 3.924,
    transform: "translate(186.783 164.911)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_858",
    "data-name": "Rectangle 858",
    width: 25.022,
    height: 3.924,
    transform: "translate(140.103 171.894)",
    fill: "#ff5240"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_859",
    "data-name": "Rectangle 859",
    width: 22.763,
    height: 3.933,
    transform: "translate(167.326 179.751)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_860",
    "data-name": "Rectangle 860",
    width: 22.763,
    height: 3.933,
    transform: "translate(194.632 179.751)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_861",
    "data-name": "Rectangle 861",
    width: 4.114,
    height: 3.933,
    transform: "translate(221.27 179.751)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_862",
    "data-name": "Rectangle 862",
    width: 6.596,
    height: 3.933,
    transform: "translate(228.591 179.751)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_863",
    "data-name": "Rectangle 863",
    width: 34.445,
    height: 3.924,
    transform: "translate(204.402 171.894)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_864",
    "data-name": "Rectangle 864",
    width: 28.79,
    height: 3.924,
    transform: "translate(169.693 171.894)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_865",
    "data-name": "Rectangle 865",
    width: 34.437,
    height: 3.933,
    transform: "translate(147.902 186.594)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_866",
    "data-name": "Rectangle 866",
    width: 9.951,
    height: 3.924,
    transform: "translate(147.902 193.767)",
    fill: "#ff5240"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_867",
    "data-name": "Rectangle 867",
    width: 17.486,
    height: 3.924,
    transform: "translate(162.165 193.767)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_868",
    "data-name": "Rectangle 868",
    width: 13.183,
    height: 3.924,
    transform: "translate(186.915 193.767)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_869",
    "data-name": "Rectangle 869",
    width: 13.183,
    height: 3.924,
    transform: "translate(203.33 193.767)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_870",
    "data-name": "Rectangle 870",
    width: 17.223,
    height: 3.933,
    transform: "translate(159.469 201.204)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_871",
    "data-name": "Rectangle 871",
    width: 55.427,
    height: 3.933,
    transform: "translate(178.844 201.204)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_872",
    "data-name": "Rectangle 872",
    width: 17.214,
    height: 3.933,
    transform: "translate(147.902 208.641)",
    fill: "#ff5240"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_873",
    "data-name": "Rectangle 873",
    width: 8.607,
    height: 3.933,
    transform: "translate(168.349 208.641)",
    fill: "#ff5240"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_874",
    "data-name": "Rectangle 874",
    width: 30.678,
    height: 3.933,
    transform: "translate(181.532 208.641)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_875",
    "data-name": "Rectangle 875",
    width: 9.415,
    height: 3.933,
    transform: "translate(161.621 216.078)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_876",
    "data-name": "Rectangle 876",
    width: 4.04,
    height: 3.933,
    transform: "translate(174.268 216.078)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_877",
    "data-name": "Rectangle 877",
    width: 10.487,
    height: 3.933,
    transform: "translate(183.42 216.078)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_878",
    "data-name": "Rectangle 878",
    width: 25.022,
    height: 3.933,
    transform: "translate(196.866 216.078)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_879",
    "data-name": "Rectangle 879",
    width: 12.639,
    height: 3.933,
    transform: "translate(225.392 216.078)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_880",
    "data-name": "Rectangle 880",
    width: 38.741,
    height: 3.933,
    transform: "translate(241.263 216.078)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_881",
    "data-name": "Rectangle 881",
    width: 17.214,
    height: 3.924,
    transform: "translate(161.621 223.514)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_882",
    "data-name": "Rectangle 882",
    width: 11.567,
    height: 3.924,
    transform: "translate(184.227 223.514)",
    fill: "#c3c640"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_883",
    "data-name": "Rectangle 883",
    width: 11.567,
    height: 3.924,
    transform: "translate(200.37 223.514)",
    fill: "#c3c640"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_884",
    "data-name": "Rectangle 884",
    width: 43.316,
    height: 3.933,
    transform: "translate(161.621 230.951)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_885",
    "data-name": "Rectangle 885",
    width: 22.87,
    height: 3.933,
    transform: "translate(208.705 230.951)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_886",
    "data-name": "Rectangle 886",
    width: 17.214,
    height: 3.933,
    transform: "translate(147.902 238.388)",
    fill: "#ff5240"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_887",
    "data-name": "Rectangle 887",
    width: 12.375,
    height: 3.933,
    transform: "translate(169.693 238.388)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_888",
    "data-name": "Rectangle 888",
    width: 29.729,
    height: 3.933,
    transform: "translate(185.835 238.388)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_889",
    "data-name": "Rectangle 889",
    width: 14.799,
    height: 3.933,
    transform: "translate(217.725 238.388)",
    fill: "#c3c640"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_890",
    "data-name": "Rectangle 890",
    width: 37.397,
    height: 3.933,
    transform: "translate(235.071 238.388)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_891",
    "data-name": "Rectangle 891",
    width: 17.214,
    height: 3.933,
    transform: "translate(161.621 245.833)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_892",
    "data-name": "Rectangle 892",
    width: 13.991,
    height: 3.933,
    transform: "translate(184.631 245.833)",
    fill: "#c3c640"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_893",
    "data-name": "Rectangle 893",
    width: 9.011,
    height: 3.933,
    transform: "translate(203.726 245.833)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_894",
    "data-name": "Rectangle 894",
    width: 31.617,
    height: 3.933,
    transform: "translate(217.857 245.833)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_895",
    "data-name": "Rectangle 895",
    width: 9.011,
    height: 3.933,
    transform: "translate(252.97 245.833)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_896",
    "data-name": "Rectangle 896",
    width: 9.687,
    height: 3.933,
    transform: "translate(188.795 186.594)",
    fill: "#ff5240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2010",
    "data-name": "Path 2010",
    d: "M327,184.393a1.773,1.773,0,1,0,1.773-1.773A1.773,1.773,0,0,0,327,184.393Z",
    transform: "translate(-57.418 -32.055)",
    fill: "#c3c640"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2011",
    "data-name": "Path 2011",
    d: "M335.35,184.393a1.764,1.764,0,1,0,.517-1.256A1.773,1.773,0,0,0,335.35,184.393Z",
    transform: "translate(-58.884 -32.055)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2012",
    "data-name": "Path 2012",
    d: "M343.73,184.393a1.764,1.764,0,1,0,.517-1.256A1.773,1.773,0,0,0,343.73,184.393Z",
    transform: "translate(-60.355 -32.055)",
    fill: "#ff5240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2013",
    "data-name": "Path 2013",
    d: "M514.68,432.775s.824,13.612,3.479,13.809h13.364l16.6-.1s-.107-4-4.947-4.848-12.977-4.254-15.92-10.668C524.153,424.242,514.68,432.775,514.68,432.775Z",
    transform: "translate(-90.366 -75.192)",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2014",
    "data-name": "Path 2014",
    d: "M503.3,238.37s7.84,4.46,10.034,4.46,10.808-1.649,13.191-.437,6.744,6.159,7.56,7.775c1.468,2.9-5.9,1.649-9.39-.824a2.177,2.177,0,0,0-1.74-.363c-1.806.4-5.548,1.08-7.362.4-2.473-.9-15.261-1.9-15.261-1.9Z",
    transform: "translate(-87.847 -41.84)",
    fill: "#e49963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2015",
    "data-name": "Path 2015",
    d: "M431.56,162.992s8.129,57.777,21.592,62.946c6.637,2.556,36,8.343,44.677,8.929,0,0,2.127-1.731,1.608-8.747,0,0-30.752-11.295-35.121-17.437-6.5-9.135,4.04-37.331-4.122-45.913S438.3,150.5,431.56,162.992Z",
    transform: "translate(-75.774 -27.193)",
    fill: "#ed7d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2016",
    "data-name": "Path 2016",
    d: "M432.678,305.126a100.467,100.467,0,0,0,7.939,11.361c8.731,11.031,18.245,20.125,19.9,28.715a38.942,38.942,0,0,0,1.533,5.507c.692,1.97,1.55,4.04,2.539,6.175,3.7,8.055,9.25,17.082,14.782,25.286,9.572,14.172,18.566,26.011,18.566,26.011l16.489-.709c-.66-1.649-7.857-21.229-17.486-45.155-3.908-9.712-8.071-20.042-12.078-30.01l-1.6-3.966-3.611-8.978-16.242-40.357s-36.135-13.686-39.887-4.815C420.451,281.506,422.966,288.67,432.678,305.126Z",
    transform: "translate(-74.146 -47.597)",
    fill: "#599dad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2017",
    "data-name": "Path 2017",
    d: "M466.107,386.52s-11.476,7.42-10.363,9.77c.148.322,6.488,11.682,6.488,11.682l8.187,14.452s3.438-2.045,1.814-6.694-2.613-13.414,1.558-19.111C478.2,390.626,466.107,386.52,466.107,386.52Z",
    transform: "translate(-80.006 -67.842)",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2018",
    "data-name": "Path 2018",
    d: "M465.849,379.6s-7.173-6.323-8.434-10.965c0,0,29.556-35.451,35.97-43.349.289-.363.214-.767-.173-1.2-4.84-5.458-58.618-16.555-65.651-27.5a33.869,33.869,0,0,1-4.543-10.47,24.744,24.744,0,0,1-.33-11.278l53.713-1.55s44.718,27.841,49.78,46.828S465.849,379.6,465.849,379.6Z",
    transform: "translate(-74.133 -47.968)",
    fill: "#6bb7bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2019",
    "data-name": "Path 2019",
    d: "M493.383,324.6c-4.84-5.458-58.618-16.555-65.651-27.5a33.869,33.869,0,0,1-4.543-10.47v-6.793l22.829-3.595s6.472,19.927,25.648,27.4C489.624,310.671,493.029,323.037,493.383,324.6Z",
    transform: "translate(-74.304 -48.489)",
    fill: "#5aa9ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2020",
    "data-name": "Path 2020",
    d: "M463.966,154.953C453.1,157.764,435.11,147.7,435.11,147.7a26.683,26.683,0,0,0,9.588-15.03c.132-.519.247-1.047.355-1.6l5.581-1.179,8.294,7.42a70.138,70.138,0,0,1-1.22,8.393c-.181.923-.387,1.921-.627,2.976A25.722,25.722,0,0,1,463.966,154.953Z",
    transform: "translate(-76.397 -22.799)",
    fill: "#e49963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2021",
    "data-name": "Path 2021",
    d: "M421.068,202.875c1.55,20.933-.495,52.764,1.27,58.288,1.525,4.757,18.888,1.929,25.813.338,2.572-.585,5.672-1.426,8.887-2.416,8.945-2.778,18.7-6.736,19.745-9.671a3.062,3.062,0,0,0,.1-.338,2.687,2.687,0,0,0,0-1.228c-.354-1.5-1.7-3.116-1.855-6.826-.173-4.122-.148-9.019-.305-14.263a13.543,13.543,0,0,0-.082-1.822v-.544c-.148-5.845-.453-12-.824-18.088-.231-3.834-.486-7.626-.824-11.254-.775-9.382-1.83-17.717-3.224-22.986-2.275-8.6-7.288-14.205-11.855-18.311l-3.3-2.836a19.111,19.111,0,0,1-11.971-1.566c-4.262-2.028-5.771-3.479-6.48-2.927C426.311,153.993,419.23,177.292,421.068,202.875Z",
    transform: "translate(-73.881 -25.679)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2022",
    "data-name": "Path 2022",
    d: "M459.336,265.9c8.945-2.778,18.7-6.736,19.745-9.671a3.081,3.081,0,0,0,.1-.338c0-.412,0-.824,0-1.228-.354-1.5-1.7-3.116-1.855-6.826-.173-4.122-.148-9.019-.305-14.263a13.543,13.543,0,0,0-.082-1.822V231.2l-36.21-46.1S416.408,235.754,459.336,265.9Z",
    transform: "translate(-76.179 -32.489)",
    fill: "#ed7d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2023",
    "data-name": "Path 2023",
    d: "M460.97,137.326a70.133,70.133,0,0,1-1.22,8.393c-8.1-2.622-11.781-9.943-13.01-13.051.132-.519.247-1.047.355-1.6l5.581-1.179Z",
    transform: "translate(-78.439 -22.799)",
    fill: "#d68d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2024",
    "data-name": "Path 2024",
    d: "M461.93,137.892s-17.676-2.952-15.664-13.925,1.08-18.756,12.449-17.313,12.787,6.01,13.01,9.836S466.58,138.378,461.93,137.892Z",
    transform: "translate(-78.328 -18.69)",
    fill: "#e49963"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_897",
    "data-name": "Rectangle 897",
    width: 1.641,
    height: 42.912,
    transform: "translate(454.739 213.637) rotate(-162)",
    fill: "#4a75cb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_898",
    "data-name": "Rectangle 898",
    width: 45.031,
    height: 2.696,
    transform: "translate(454.719 213.668) rotate(-178.78)",
    fill: "#4a75cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2025",
    "data-name": "Path 2025",
    d: "M498.06,258.825s14.461,3.817,19.886,3.413,9.943-2.976,10.619-4.328,2.119-3.735-1.575-3.3-8.731,1.22-8.888.511,3.009-.643,3.009-.643.956-1.385-.247-1.443-4.724-1-6.027-.346-2.473,3.059-3.471,2.96-12.1-5.021-12.1-5.021Z",
    transform: "translate(-87.448 -43.992)",
    fill: "#e49963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2026",
    "data-name": "Path 2026",
    d: "M435.91,166.157s1.715,58.313,14.518,64.941c6.324,3.3,34.858,12.259,43.423,13.793,0,0,2.3-1.476,2.564-8.517,0,0-29.325-14.609-32.978-21.2-5.458-9.794,8.129-36.655.965-46.086S443.981,154.483,435.91,166.157Z",
    transform: "translate(-76.538 -27.983)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2027",
    "data-name": "Path 2027",
    d: "M445.913,126.979s-.206-3.759,2.119-5.92c0,0-.824-3.776.684-4.4s1.806,2.556,2.473,2.053a15.252,15.252,0,0,0,5.046-6.348c1.3-3.487,13.274.742,14.667,1.369s5.87-1.649,6.744-3.545a26.422,26.422,0,0,1-3.611-3.487c-1.121-1.492-8.962-11.542-19.919-8.714s-12.449,8.1-11.823,12.573S441.429,125.479,445.913,126.979Z",
    transform: "translate(-77.637 -17.111)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2028",
    "data-name": "Path 2028",
    d: "M70.372,301.16l-3.29,22.516-10.33,70.8L55.68,401.8l7.906,1.187,43.9,6.6,7.857-54.182,4-27.578.049-.33L99.738,305.571Z",
    transform: "translate(-9.786 -52.857)",
    fill: "#3f964f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2029",
    "data-name": "Path 2029",
    d: "M107,317.634,87.13,314.65A8.83,8.83,0,0,1,77.1,322.07L67.64,387.811a8.813,8.813,0,0,1,7.42,10.033l19.877,2.984a8.813,8.813,0,0,1,10.025-7.42l9.456-65.749A8.83,8.83,0,0,1,107,317.634Z",
    transform: "translate(-11.886 -55.228)",
    fill: "#4ead60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2030",
    "data-name": "Path 2030",
    d: "M96.109,346.235a14.634,14.634,0,1,0,9.607,5.775A14.642,14.642,0,0,0,96.109,346.235Z",
    transform: "translate(-13.932 -60.745)",
    fill: "#3f964f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2031",
    "data-name": "Path 2031",
    d: "M109.12,306.51l.033,22.862,19.572-.61.33-.017-.28-.313Z",
    transform: "translate(-19.168 -53.801)",
    fill: "#3f964f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2032",
    "data-name": "Path 2032",
    d: "M127.677,340.541,109.16,334.11l19.572-.61Z",
    transform: "translate(-19.175 -58.539)",
    fill: "#193f1e",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2033",
    "data-name": "Path 2033",
    d: "M108.7,306.447l.033,22.862L106.75,306.15Z",
    transform: "translate(-18.752 -53.738)",
    fill: "#193f1e",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2034",
    "data-name": "Path 2034",
    d: "M67.314,328.47,57,399.265l6.843,8.516,43.9,6.6,7.832-54.141-7.824-4.312c-2.952-1.649-7.989,1.566-12.449,7.42Z",
    transform: "translate(-10.018 -57.651)",
    fill: "#193f1e",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_899",
    "data-name": "Rectangle 899",
    width: 52.385,
    height: 122.331,
    transform: "translate(0 287.656) rotate(-38.77)",
    fill: "#3f964f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2035",
    "data-name": "Path 2035",
    d: "M37.377,329.71,21.712,342.316a8.822,8.822,0,0,1-1.352,12.367l54.5,67.876a8.813,8.813,0,0,1,12.367,1.352L102.9,411.322a8.822,8.822,0,0,1,1.352-12.367l-54.5-67.893a8.805,8.805,0,0,1-12.367-1.352Z",
    transform: "translate(-3.585 -57.869)",
    fill: "#4ead60"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_256",
    "data-name": "Ellipse 256",
    cx: 14.642,
    cy: 14.642,
    rx: 14.642,
    ry: 14.642,
    transform: "translate(39.375 314.975) rotate(-34.89)",
    fill: "#3f964f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2036",
    "data-name": "Path 2036",
    d: "M94.036,379.667l-24.906,45.2,45.889,25.286,24.907-45.2-32.294-17.792c4.947-9.069,5.944-18.031,2.21-20.092S99.049,370.648,94.036,379.667Z",
    transform: "translate(-12.147 -64.353)",
    fill: "#3f964f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_900",
    "data-name": "Rectangle 900",
    width: 36.861,
    height: 58.008,
    transform: "matrix(-0.876, -0.483, 0.483, -0.876, 101.976, 371.388)",
    fill: "#4ead60"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_257",
    "data-name": "Ellipse 257",
    cx: 13.076,
    cy: 13.076,
    r: 13.076,
    transform: "translate(82.915 350.443) rotate(-79.3)",
    fill: "#3f964f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2037",
    "data-name": "Path 2037",
    d: "M98.8,379.668,96.25,384.3l45.88,25.277,11.542-20.966L114.586,367.07c-3.735-2.053-10.792,3.578-15.8,12.6Z",
    transform: "translate(-16.908 -64.356)",
    fill: "#193f1e",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2038",
    "data-name": "Path 2038",
    d: "M118.04,367.16c3.735,2.061,2.737,11.031-2.21,20.092l45.889,25.277h0c4.947-9.069,5.936-18.031,2.2-20.083Z",
    transform: "translate(-20.346 -64.446)",
    fill: "#3f964f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2039",
    "data-name": "Path 2039",
    d: "M128.55,372.7c1.649.907,2.275,3.207,1.871,5.928a5.186,5.186,0,0,1,2.135,6.917h0l23.2,12.779h0a5.144,5.144,0,0,1,6.348-2.168c.429-2.754-.2-5.079-1.855-5.994Z",
    transform: "translate(-22.579 -65.419)",
    fill: "#4ead60"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyCode);
export default __webpack_public_path__ + "static/media/copy-code.d2489f37740622bb94ee9bffad2fe783.svg";
export { ForwardRef as ReactComponent };